import { Stack, Typography } from "@mui/material"
import { formatMoney } from "../format-utils"

const MODE_FIXED = "fixed-annual"

export function RateCardTradeRow({ item, currencySymbol }) {
    return (
        <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ py: 1, px: 1, borderBottom: "1px dotted", borderColor: "divider" }}
        >
            <Typography variant="body2" sx={{ fontSize: 16 }}>
                {item.tradeName || item.tradeId}
            </Typography>
            <Typography variant="body2" sx={{ fontSize: 16 }}>
                {formatRate()}
            </Typography>
        </Stack>
    )

    function formatRate() {
        if (item.mode === MODE_FIXED) {
            return `${currencySymbol} ${formatMoney(item.fixedAnnualAmount)} / yr`
        }
        return `${currencySymbol} ${formatMoney(item.hourlyRate)} / hr`
    }
}
